import _ from 'lodash'
import moment from 'moment'

export function createESubmissionPolicy() {
  function generatePdfProps(quickQuotePdfProps, esubPdfProps) {
    const biProps = _.cloneDeep(quickQuotePdfProps)
    const { insured, payer } = esubPdfProps

    biProps.data.effectiveDate = moment().format('YYYY-MM-DD')
    biProps.data.insureds[0].firstName = insured.firstName
    biProps.data.insureds[0].lastName = insured.lastName

    if (biProps.data.payers?.length && !_.isEmpty(payer)) {
      biProps.data.payers[0].firstName = payer.firstName
      biProps.data.payers[0].lastName = payer.lastName
    }

    return biProps
  }

  return {
    generatePdfProps,
  }
}
